export const getNotificationTime = time => {
  if (time) {
    return new Date(time)
  } else {
    let date = new Date()
    date.setHours(6, 0, 0)
    return date
  }
}
